import { render, staticRenderFns } from "./DashboardItem.component.vue?vue&type=template&id=3ab59289&"
import script from "./DashboardItem.component.vue?vue&type=script&lang=js&"
export * from "./DashboardItem.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports